
import React, { useEffect, useRef, useState, useContext } from 'react';
import { FormattedMessage } from "react-intl";
import { ArrowRightIcon } from '@heroicons/react/outline';

import { LocaleContext } from "../i18n/LocaleContext";
import localeList from "../i18n/messages";

type Props = {
    handleSubmit: (event: any, value : string) => string;
};

const InputField = ({handleSubmit} : Props) => {

    const { locale } = useContext(LocaleContext);
    const [value, setValue] = useState('');

    const [msg, setMsg] = useState("Game4");

    function exSubmit(e : any) {
      var answ = handleSubmit(e, value);
      if (answ == "") {
        setValue("");
      }
      setMsg(answ);
    }

    return (
        
        <div className="background">
        <form onSubmit={e => exSubmit(e)}>
          <input type="text" value={value} onChange={e => setValue(e.target.value)} placeholder={localeList[locale]["Game1"]} id="country"></input>

          <ArrowRightIcon
            className="h-6 w-6 stroke-white grow" strokeWidth="2"
            id="submit"
            onClick={e => exSubmit(e)}
          />

          <p className='text-sm p-1 px-4 text-center'>
          {msg !== "" ? 
          <FormattedMessage
      id={msg}
      values={{
        span: (chunks: string) => {
          try {
            const [click, tap] = JSON.parse(chunks);
            return <span>{click}</span>;
          } catch (e) {
            return <span>{chunks}</span>;
          }
        },
      }}
    /> : ''}</p> 

        </form>
        
      </div>
    )};

export default InputField;